
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supplier/[id]",
      function () {
        return require("private-next-pages/supplier/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supplier/[id]"])
      });
    }
  